import {
    SAVE_HI_SENSE_GRAPH,
    HI_SENSE_GRAPH_API_LOADING
} from '../../constants/graphConstants/hiSenseGraphConstants';

/**
 * Reducer function for managing hiSenese graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const hiSenseGraphReducer = (state = {
    loading: false, 
    hiSenseGraph : [], 
    yAxisLabels : [], 
    apCount : [], 
    qoeActive : [],
    apiError: null
}, action) => {
	switch (action.type) {
		case SAVE_HI_SENSE_GRAPH:
            return {
                ...state, 
                loading: false, 
                ...action.payload  
            };
        case HI_SENSE_GRAPH_API_LOADING:
            return { 
                ...state,
                apCount : [], 
                qoeActive : [],
                hiSenseGraph : [], 
                yAxisLabels : [],
                apiError: null,
                loading: action.payload, 
            };
		default:
			return state;
	}
};